import React, { Component } from "react";
import { Table, Checkbox } from "semantic-ui-react";
import "../accounting.css";
class TMTable extends Component {
  genextracells(param) {
    if (param !== undefined && param !== "") {
      return <Table.Cell>{param}</Table.Cell>;
    }
  }
  gentnmrows() {
    return this.props.tnms.map((tnm, index) => {
      if (this.props.massdelete) {
        return (
          <Table.Row>
            <Table.Cell>
              <Checkbox
                defaultChecked
                onChange={tnm => {
                  this.props.handleDelList(tnm);
                }}
              />
            </Table.Cell>
            <Table.Cell>{tnm.custnumber}</Table.Cell>
            <Table.Cell>{tnm.tmnumber}</Table.Cell>
            <Table.Cell>{tnm.workordernumber}</Table.Cell>
            <Table.Cell>{tnm.wedate}</Table.Cell>
            <Table.Cell>{tnm.createdate}</Table.Cell>
            <Table.Cell>{tnm.tmnumber}</Table.Cell>
            <Table.Cell>{tnm.amount.toFixed()}</Table.Cell>
            <Table.Cell>{tnm.invoicenumber}</Table.Cell>
          </Table.Row>
        );
      } else if (this.props.create) {
        return (
          <Table.Row>
            <Table.Cell>
              <Checkbox
                checked={tnm.included}
                onChange={(e, { value }) => {
                  this.props.updatelist(index, !tnm.included);
                }}
              />
            </Table.Cell>
            <Table.Cell>{tnm.custnumber || "-"}</Table.Cell>
            {this.genextracells(tnm.tmnumber)}
            <Table.Cell>{tnm.workordernumber}</Table.Cell>
            <Table.Cell>{tnm.wedate}</Table.Cell>
            {this.genextracells(tnm.createdate)}
            <Table.Cell>${tnm.amount.toFixed()}</Table.Cell>
            {this.genextracells(tnm.invoicenumber)}
          </Table.Row>
        );
      }
    });
  }
  genextraheadercell(param) {
    if (param === "Included") {
      return (
        <Table.HeaderCell singleLine>
          <Checkbox
            checked={this.props.allSelect}
            label={param}
            onChange={(e, { value }) => {
              this.props.checkall(!this.props.allSelect);
            }}
          />
        </Table.HeaderCell>
      );
    }
    if (this.props.tableoptions && this.props.tableoptions.includes(param)) {
      return <Table.HeaderCell singleLine>{param}</Table.HeaderCell>;
    }
  }
  gentmtable() {
    if (this.props.tnms) {
      return (
        <div id="TMTables">
          <Table celled selectable>
            <Table.Header>
              <Table.Row>
                {this.genextraheadercell("Included")}
                <Table.HeaderCell singleLine>Customer Number</Table.HeaderCell>
                {this.genextraheadercell("TM Number")}
                <Table.HeaderCell singleLine>Work Order #</Table.HeaderCell>
                <Table.HeaderCell singleLine>WE Date</Table.HeaderCell>
                <Table.HeaderCell singleLine>Create Date</Table.HeaderCell>
                <Table.HeaderCell singleLine>TM Amount</Table.HeaderCell>
                {this.genextraheadercell("Invoice #")}
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.gentnmrows()}</Table.Body>
          </Table>
        </div>
      );
    }
  }
  render() {
    return <div className="TMTable">{this.gentmtable()}</div>;
  }
}
export default TMTable;



// WEBPACK FOOTER //
// ./src/components/accounting/tnm/tmtable.jsx